import { useEstimationQueryActions } from '@/api/hooks/estimationQueryActions';

export const useEstimationStage = (estimationId: string) => {
  const { useGetEstimation } = useEstimationQueryActions();
  const { data } = useGetEstimation(estimationId);

  if (!data) {
    return undefined;
  }

  return data.estimation.stage;
};
